import React from 'react';

import Button from '@atlaskit/button';
import { openDialog } from 'src/services/jira';
import { useSession } from 'src/services/session';

import { trackEvent } from 'src/lib/analytics';
import { locationReload } from 'src/lib/history';

const onOpenModal = (e) => {
  e.preventDefault();
  trackEvent('sidebar_incident', { label: 'link_incident' });
  openDialog('/integration-jira-ui/issue_sidebar/modal_link_incident', {
    width: '40vw',
    minHeight: 400,
    onClose: () => {
      locationReload();
    }
  });
};

const LinkIncidentButton = () => {
  const { loggedIn } = useSession();
  return (
    <div data-cy="link-incident-button">
      <div> <Button appearance="subtle-link" isDisabled={!loggedIn} onClick={onOpenModal}>Link existing incident</Button></div>
      {!loggedIn && <div>Please Login with PagerDuty to Link existing incidents</div>}
    </div>
  );
};

export default LinkIncidentButton;
